/** @format */

import {OrderDescriptionColumn} from './table_columns/order_description_column';
import {useArchivedOrdersContext} from '../archived_orders_context_provider';
import {LoadMoreContextual} from '../../../../components/search/load_more';
import {ActionColumn} from './table_columns/action_column';
import {DesignsList} from './designs_table/designs_list';
import DateTime from 'frontier/utilities/format/date';
import {IdColumn} from './table_columns/id_column';
import {Table, Toast} from '@sttark/design-system';
import {Loading} from 'frontier-utilities';
import React, {useState} from 'react';

// styles
import './grouped_by_order_list.scss';

export const GroupedByOrderList = () => {
    const [toast, setToast] = useState({
        isDanger: false,
        isOpen: false,
        message: ''
    });

    const {state, handleRemoveOrderFromList} = useArchivedOrdersContext();
    const {carts, loading} = state;

    const handleError = () => {
        setToast({
            message: 'Something went wrong. Please try again.',
            isOpen: true,
            isDanger: true
        });
    };

    const hideToast = () => {
        setToast({
            isDanger: false,
            isOpen: false,
            message: ''
        });
    };

    if (loading) {
        return <Loading />;
    }

    if (carts.length === 0 && !loading) {
        return (
            <div className="reorder__design-list-88ty__alert">
                You don't have any archived orders yet!
            </div>
        );
    }

    function onSuccessfulArchive(orderId) {
        setToast({
            message: 'Order has been successfully unarchived.',
            isDanger: false,
            isOpen: true
        });

        handleRemoveOrderFromList(orderId);
    }

    return (
        <div className="grouped-by-order-list-310kv">
            <Toast
                danger={toast.isDanger}
                autoHideDuration={4000}
                isOpen={toast.isOpen}
                onClose={hideToast}
                zIndex={3001}
                autoHide>
                <p className="color-structure-white m-0">{toast.message}</p>
            </Toast>
            <Table
                columns={[
                    {
                        title: 'Order ID ',
                        index: 'order_id',
                        key: 'order_id'
                    },
                    {
                        index: 'product_type',
                        key: 'product_type',
                        title: 'Type'
                    },
                    {
                        title: 'Date',
                        index: 'date',
                        key: 'date'
                    },
                    {
                        index: 'description',
                        title: 'Description',
                        key: 'description'
                    },
                    {
                        index: 'action',
                        key: 'action',
                        title: ''
                    }
                ]}
                rows={carts.map(order => {
                    return {
                        key: order.id,
                        order_id: <IdColumn order={order} />,
                        product_type: <p className="m-0 p-0">{order.product_type_label}</p>,
                        date: (
                            <p className="orders-list-table-active-31cs__column--date m-0 p-0">
                                {DateTime(order.created)}
                            </p>
                        ),
                        description: <OrderDescriptionColumn order={order} />,
                        action: (
                            <ActionColumn
                                onSuccessfulSave={onSuccessfulArchive}
                                onError={handleError}
                                order={order}
                            />
                        ),
                        renderData: order
                    };
                })}
                rememberExpanded
                isExpandable
                defaultExpanded
                borderedRows>
                <DesignsList />
            </Table>
            <div style={{marginTop: '24px'}}>
                <LoadMoreContextual />
            </div>
        </div>
    );
};
